import Loader from '../../../../components/Loader/Loader'

const VisitorLoader = () => {
  return (
    <div className="visitor-loader-container">
      <Loader className="loader" />
    </div>
  )
}

export default VisitorLoader
